import { render, staticRenderFns } from "./detailItem.vue?vue&type=template&id=3441285c&scoped=true&"
import script from "./detailItem.vue?vue&type=script&lang=js&"
export * from "./detailItem.vue?vue&type=script&lang=js&"
import style0 from "./detailItem.vue?vue&type=style&index=0&id=3441285c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3441285c",
  null
  
)

export default component.exports